import { useContext } from 'react';

import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { AuthModalContext } from '@/context/AuthModalContextProvider';
import { useAnalytics } from '@/hooks/analytics';
import { useUserState } from '@/hooks/store';
import redirect from '@/utils/legacy/redirect';
import { userCanTrial } from '@/utils/subscriptions';

export function useFreeTrialClick(): () => Promise<void> {
	const user = useUserState();
	const { logEvent, logEventAsync } = useAnalytics();
	const { setAuthPrompt } = useAuthPrompt();
	const { setIsModalOpen } = useContext(AuthModalContext);

	return async () => {
		const redirectUrl = userCanTrial(user) ? '/freetrial' : '/subscribe';
		const logArgs = {
			eventName: 'Free Trial Details : Start Trial : Clicked',
			eventProps: { button_location: 'bottom' },
		};

		if (user?.id) {
			await logEventAsync(logArgs);
			redirect(redirectUrl);
		} else {
			logEvent(logArgs);
			setAuthPrompt('signup');
			if (setIsModalOpen) {
				setIsModalOpen(true);
			}
		}
	};
}
